import * as signalR from '@microsoft/signalr';
import { store } from '../../Store/store';
import { PostRequest } from './Apibase';
import { SubscribeToVehicle } from './RidesServices';
import { updateIsRefreshApi } from '../../Store/Slices/ridesSlice';
import { format } from 'date-fns';
import Helpers from '../../Shell/Helper';
import { playAudio } from '../../Shell/Helpers/AudioUnlockHelper';


let connection = null;

const startSignalRConnection = async (vehicleUid = null) => {
    try {
        // Stop any existing connection before starting a new one
        if (connection) {
            await connection.stop();
            console.log('Previous SignalR connection stopped.');
            connection = null;
        }

        const res = await PostRequest('/api/mobile/GetSignalRConnection', null, true);
        //check validation

        if (!res?.data) throw new Error("Invalid SignalR connection response");

        const { endpoint, token } = JSON.parse(res?.data);

        connection = new signalR.HubConnectionBuilder()
            .withUrl(endpoint, {
                accessTokenFactory: () => token,
            })
            .withAutomaticReconnect()
            .build();

        const broadcastHandler = async (data) => {
            console.log("Broadcast Message Received:", data);
            try {
                // validate data handle validations

                const parsed = data ? JSON.parse(data) : null;

                if (parsed?.type === 'rides.schedulechanged') {
                    const obj = parsed?.obj;
                    console.log("Schedule Changed:", obj);
                    if (obj?.vehicleUID === vehicleUid) {
                        // Dispatch an action to update the state
                        store.dispatch(updateIsRefreshApi(true));
                        // play sound
                        let filepath = Helpers.getNotificationSoundPath('Schedule');

                        const success = await playAudio(filepath);
                        if (success) {
                            console.log("Audio playing...");
                        }
                    }
                }
            } catch (e) {
                console.error('Failed to parse broadcastMessage:', e);
            }
        };

        connection.on('broadcastMessage', broadcastHandler);

        // ✅ Expose handler for dev testing
        if (typeof window !== 'undefined') {
            window._triggerBroadcastMessage = broadcastHandler;
        }

        await connection.start();

        console.log('SignalR Connected.');

        if (vehicleUid) {
            let res = await SubscribeToVehicle(vehicleUid, format(new Date(), "yyyy-MM-dd"));
            console.log("SubscribeToVehicle Response: ", res);
        }

    } catch (error) {
        console.log('Error initializing SignalR:', error);
        connection = null;
    }
};

const stopSignalRConnection = async () => {
    if (connection) {
        try {
            await connection.stop();
            console.log('SignalR Disconnected.');
            connection = null;
        } catch (err) {
            console.error('Error while stopping SignalR connection: ', err);
        }
    }
};

const isSignalRConnected = () => {
    if (!connection) return false;
    return connection.state === signalR.HubConnectionState.Connected;
};


const SignalRService = {
    startSignalRConnection,
    stopSignalRConnection,
    isSignalRConnected
};
export default SignalRService;